import { useEffect } from 'react';
import { useMediaQuery } from './useMediaQuery';
import { useUIStore } from '@/stores/uiStore';

export function useMobileDetection() {
  const setMobile = useUIStore((state) => state.setMobile);
  const setTablet = useUIStore((state) => state.setTablet);
  
  const isMobile = useMediaQuery('(max-width: 640px)');
  const isTablet = useMediaQuery('(min-width: 641px) and (max-width: 1024px)');
  
  useEffect(() => {
    setMobile(isMobile);
    setTablet(isTablet);
  }, [isMobile, isTablet, setMobile, setTablet]);
  
  return { isMobile, isTablet, isDesktop: !isMobile && !isTablet };
}